import React from 'react';
import { Box, Button } from '@mui/material';
import PrimaryActionButton from './PrimaryActionButton';

export const confirmDialogActionsSx = {
  flexShrink: 0,
  justifyContent: 'space-between',
};

export const confirmDialogActionsWithSecondarySx = {
  flexShrink: 0,
  flexDirection: { xs: 'column', sm: 'row' },
  alignItems: { xs: 'stretch', sm: 'center' },
  justifyContent: { xs: 'stretch', sm: 'space-between' },
  gap: 1,
  width: '100%',
};

const ConfirmDialogActions = ({
  onCancel,
  cancelText,
  onConfirm,
  confirmText,
  onSecondaryConfirm,
  secondaryConfirmText,
  loading = false,
  confirmDisabled = false,
  confirmButtonSx,
}) => {
  const stackedActionSx = secondaryConfirmText
    ? { width: { xs: '100%', sm: 'auto' } }
    : undefined;

  const cancelButton = (
    <Button
      onClick={onCancel}
      color="inherit"
      disabled={loading}
      sx={secondaryConfirmText
        ? { order: { xs: 3, sm: 1 }, ...stackedActionSx }
        : undefined}
    >
      {cancelText}
    </Button>
  );

  const confirmButton = (
    <PrimaryActionButton
      onClick={onConfirm}
      disabled={loading || confirmDisabled}
      sx={[
        secondaryConfirmText
          ? { order: { xs: 1, sm: 2 }, width: { xs: '100%', sm: 'auto' } }
          : null,
        confirmButtonSx,
      ]}
    >
      {confirmText}
    </PrimaryActionButton>
  );

  if (!secondaryConfirmText || !onSecondaryConfirm) {
    return (
      <>
        {cancelButton}
        {confirmButton}
      </>
    );
  }

  return (
    <>
      {cancelButton}
      <Box
        sx={{
          display: 'flex',
          order: { xs: 1, sm: 2 },
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'stretch', sm: 'center' },
          justifyContent: { xs: 'stretch', sm: 'flex-end' },
          gap: 1,
          width: { xs: '100%', sm: 'auto' },
          maxWidth: '100%',
          minWidth: 0,
        }}
      >
        <Button
          onClick={onSecondaryConfirm}
          color="inherit"
          disabled={loading || confirmDisabled}
          sx={{ order: { xs: 2, sm: 1 }, ...stackedActionSx }}
        >
          {secondaryConfirmText}
        </Button>
        {confirmButton}
      </Box>
    </>
  );
};

export default ConfirmDialogActions;
